import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { FormComponentLookup, EntryConfigInterface, PageConfigInterface, FormNavigationConfig, DefaultFormConfig } from '@ptl/forms';
import { FormPageComponentClass } from '@ptl/forms';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { FormConfig } from '@ptl/forms';
import { ConfirmationPageUrls } from 'src/app/angular-elements/shared/components/interfaces/confirmation-page-urls.interface';
import { EnrollmentFormConfig } from '../../types/enrollment-form-config.interface';
import { DateService } from 'src/app/shared/services/date.service';
import { CommonUtilityService } from 'src/app/shared/utility-services/common-utility.service';
import { SeniorMarketsEnrollmentSubmissionService } from 'src/app/angular-elements/shared/services/enrollment/senior-markets/enrollment-submission.senior-markets';
import { PlansStateStructure } from '../../../../plan-selection/configs/interfaces/plansStateStructure.interface';


@FormComponentLookup('page-review')
@Component({
    selector: 'app-page-review',
    templateUrl: './page-review.component.html',
    styleUrls: ['./page-review.component.scss'],
    standalone: false
})

export class PageReviewComponent extends FormPageComponentClass<FormNavigationConfig> implements OnInit {

  @ViewChild('reviewPage', { static: true }) reviewHtml: ElementRef;

  isSubmitting = false;
  reviewConfigReady = false;
  confirmationPageUrls: ConfirmationPageUrls;
  formJson: EnrollmentFormConfig = null;

  constructor(
    private reducerUtilityService: ReducerUtilityService,
    private submissionCallbacks: SeniorMarketsEnrollmentSubmissionService,
    private dateUtility: DateService,
    private commonUtilityService: CommonUtilityService
  ) {
    super();
  }

  ngOnInit() {
    this.initPageConfig();
  }

  //  {
  //   order: number,
  //   display: boolean,
  //   editType: 'edit-in-place' | 'on-page' | 'not-editable'
  // };

  public initPageConfigHook() {

    this.formConfig.pages[this.currentPage].entries = this.formConfig.pages[this.currentPage]?.custom?.reviewEntries || [];

    this.formConfig.pages.forEach((page: PageConfigInterface, pageNumber: number) => {
      if (page.display === true && page.pageType !== 'review') {
        // set page number for entry so we can retrive it on edit
        page.entries.forEach((entry: EntryConfigInterface) => {
          entry.pageNumber = pageNumber;

          // For review components, add the page number to the review config so they can have the page for edit as well
          if (entry.custom?.reviewMode === 'entryReviewTemplate') {
            entry.custom.reviewEntryConfig.pageNumber = pageNumber;
          }

          // replace string mappings again in case the page refreshed - this part can go
          // away when we switch to just ptl-entry-as-json tags. We need the initial entry processing
          // to trigger for this to happen automatically
          let replacementMap = this.formConfig.replacementMap;
          if (replacementMap) {
            for (let key in replacementMap) {
              if (replacementMap[key] != null) {
                if (entry?.formControlAttributes?.label?.includes(key)) {
                  entry.formControlAttributes.label = entry.formControlAttributes.label.replace(new RegExp(key, 'g'), replacementMap[key]);
                }
                if (entry?.base?.text?.includes(key)) {
                  entry.base.text = entry.base.text.replace(new RegExp(key, 'g'), replacementMap[key]);
                }
              }
            }
          }
        });

        const concatEntries = this.formConfig.pages[this.currentPage].entries.concat(page.entries);
        this.formConfig.pages[this.currentPage].entries = concatEntries;
      }
    });

    this.formConfig.pages[this.currentPage].entries.sort((a, b) => {
      const aReviewOrder = (a.custom && a.custom.reviewOrder && Number(a.custom.reviewOrder)) || 1000;
      const bReviewOrder = (b.custom && b.custom.reviewOrder && Number(b.custom.reviewOrder)) || 1000;
      return aReviewOrder - bReviewOrder;
    });

    this.confirmationPageUrls = {
      confirmationPageUrl: this.formConfig.form.customConfigs.confirmationPageUrl,
      maConfirmationPageUrl: this.formConfig.form.customConfigs.confirmationPageUrl,
      medigapConfirmationPageUrl: this.formConfig.form.customConfigs.medigapConfirmationPageUrl,
      whbConfirmationPageUrl: this.formConfig.form.customConfigs.whbConfirmationPageUrl,
      pdpConfirmationPageUrl: this.formConfig.form.customConfigs.pdpConfirmationPageUrl
    };

    this.pageFormGroups = this.parseToFormGroup.toFormGroup(this.formConfig.pages[this.currentPage].entries);
    this.reviewConfigReady = true;

    this.initSubmitListener();
  }

  retrieveEntry(entry: EntryConfigInterface, valueExists?: boolean) {
    if (entry.formControlAttributes && entry.formControlAttributes.connectPath && entry.formControlAttributes.formControlName) {

      const payload = this.reducerUtilityService.getPayloadStates();
      const value = payload[entry.formControlAttributes.connectPath]
        && payload[entry.formControlAttributes.connectPath][entry.formControlAttributes.formControlName] || null;

      if (valueExists) {
        return !!value;
      }

      if (value !== null) {
        switch (entry.base.componentType) {
          case 'text-input':
            return value;
          case 'date-of-birth-input':
          case 'date-input':
          case 'coverage-dropdown-select':
            return this.dateUtility.getDateAsFormattedString(value, 'MM/DD/YYYY');
          case 'radio-input':
            let radioValue = null;
            for (const option in entry.radioGroupAttributes.optionAttributes) {
              if (entry.radioGroupAttributes.optionAttributes[option].value === value) {
                radioValue = entry.radioGroupAttributes.optionAttributes[option].label;
              }
            }
            return radioValue;
          case 'dropdown-select':
            let dropdownValue = null;
            for (const option in entry.selectAttributes.optionAttributes) {
              if (entry.selectAttributes.optionAttributes[option].value === value) {
                dropdownValue = entry.selectAttributes.optionAttributes[option].label;
              }
            }
            return dropdownValue;

          case 'checkbox-input':
            return this.convertTruthyFalsyToString(value);
          default:
            return value;
        }
      }
    }
  }

  backHook(formConfig): Promise<any> {
    return new Promise((resolve, reject) => {
      if (this.isSubmitting) {
        reject();
        return;
      }

      this.formPageActions.backHook(formConfig);
      resolve(true);
    });
  }

  nextHook(formConfig): Promise<any> {

    this.saveApplicationToStorageForConfirmationPage(false)

    return new Promise((resolve, reject) => {
      this.formPageActions.nextHook(formConfig);
      resolve(resolve);
    });
  }


  submitHook(formConfig): Promise<any> {
    return new Promise(async (resolve, reject) => {
      if (this.isSubmitting) {
        reject();
        return;
      }

      this.submitLock(true);
      let result = await this.saveApplicationToStorageForConfirmationPage(true);

      // Only re-enable the button if there was an error to prevent multiple submits
      if (!result.valid) {
        this.submitLock(false);
      }

      resolve(true);
    });
  }

  saveForLaterButtonHook(formConfig): Promise<any> {
    return new Promise(async (resolve, reject) => {
      if (this.isSubmitting) {
        reject();
        return;
      }

      this.submitLock(true);
      await this.formPageActions.saveForLaterHook(formConfig);
      this.submitLock(false);

      resolve(true);
    });
  }

  saveApplicationToStorageForConfirmationPage(submit = false): Promise<any> {
    const content = this.reviewHtml.nativeElement.innerText + '\n';
    const serializedState = this.commonUtilityService.base64decode(sessionStorage.getItem('applicationForm')) || 'Your Application:\n';
    if (!/content/.test(serializedState)) {
      sessionStorage.setItem('applicationForm', this.commonUtilityService.base64encode(serializedState + content));
    }

    if (submit) {
      const planState: PlansStateStructure = this.reducerUtilityService.getState('Plans');
      return this.submissionCallbacks.submitPayload(this.confirmationPageUrls, planState?.isPlanChange);
    }
  }

  convertTruthyFalsyToString(value, returnTruthyString?, returnFalseyString?) {
    let returnValue = value ? value : 'Not Answered';

    if (['Yes', 'yes', 'YES', true, 'true', 'Y', 'y'].includes(value)) {
      returnValue = returnTruthyString || 'Yes';
    }
    if (['No', 'no', 'NO', false, 'false', 'N', 'n'].includes(value)) {
      returnValue = returnFalseyString || 'No';
    }

    return returnValue;
  }

  editQuestion(entry) {
    this.emitCustomPage(entry.pageNumber);
  }

  initSubmitListener() {
    this.subscriptionGroup.push(
      this.formStreamTrigger.subscribeToFormStream((event) => {
        if (event.type === 'submit-app') {
          this.submitButton();
        }
      })
    );
  }

  submitLock(isLocked: boolean) {
    this.isSubmitting = isLocked;
    this.formStreamTrigger.triggerFormStream({ formControlName: null, type: 'submit-locked', value: isLocked });
  }
}
